import React from 'react'
import { Route, Switch } from 'react-router'
import PaymentMethodsList from './PaymentMethodsList'
import PaymentMethodsEdit from './PaymentMethodsEdit'

const Countries = props => (
    <Switch>
        <Route exact path={props.match.url} component={PaymentMethodsList} />
        <Route exact path={`${props.match.url}/new`} component={PaymentMethodsEdit} />
        <Route exact path={`${props.match.url}/:paymentMethodID`} component={PaymentMethodsEdit} />
    </Switch>
)

export default Countries
